import { render, staticRenderFns } from "./invoice-table-input.vue?vue&type=template&id=0b590fa6&scoped=true&"
import script from "./invoice-table-input.ts?vue&type=script&lang=ts&"
export * from "./invoice-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-table-input.scss?vue&type=style&index=0&id=0b590fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b590fa6",
  null
  
)

export default component.exports